// extracted by mini-css-extract-plugin
module.exports = {"container":"c9DGhJh","attribute":"eKSsZO","bold":"Q8fpsz","values":"STQyHg","legacy":"c2E6iMm"};